/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { FlexBox, ResponsiveGridLayout, Text, Title } from '@ui5/webcomponents-react';
import { uiFullHeight, uiFullWidth } from '../../Styling/Theme/Theme';
import { ThemingParameters } from '@ui5/webcomponents-react-base/dist';
import { LanguageSwitch } from '../../controls/ShellPopOver/LanguageSwitch/LanguageSwitch';
import TimeFormat from '../timeFormat/TimeFormat';
import { useTranslations } from '../../hooks/useTranslations';

const LanguageRegion: React.FC = () => {
    const { t } = useTranslations();

    return (
        <div
            style={{
                width: uiFullWidth.width,
                height: uiFullHeight.height,
                overflow: 'hidden',
            }}
        >
            <Title
                className="ui5-title"
                level="H5"
                style={{
                    fontSize: ThemingParameters.sapFontHeader5Size,
                    color: ThemingParameters.sapPageHeader_TextColor,
                    padding: ThemingParameters.sapContent_Margin_Medium,
                    fontWeight: '900',
                }}
            >
                {t('LANGUAGE_REGION')}
            </Title>

            <div style={{ width: uiFullWidth.width, boxSizing: 'border-box' }}>
                <ResponsiveGridLayout
                    columnsXL={2}
                    columnsL={2}
                    columnsM={2}
                    columnsS={2}
                    className="ui5-grid-language"
                    style={{ alignItems: 'center', justifyContent: 'center', padding: ThemingParameters.sapContent_Margin_Small }}
                >
                    <Text
                        className="ui5-text"
                        style={{
                            fontSize: ThemingParameters.sapFontSize,
                            color: ThemingParameters.sapContent_LabelColor,
                        }}
                    >
                        {t('LANGUAGE_REGION_FORMAT')}
                    </Text>
                    <LanguageSwitch />

                    <Text
                        className="ui5-text"
                        style={{
                            fontSize: ThemingParameters.sapFontSize,
                            color: ThemingParameters.sapContent_LabelColor,
                        }}
                    >
                        {t('DATE_FORMAT')}
                    </Text>
                    <Text style={{ color: ThemingParameters.sapField_TextColor }}>{t('DATE_FORMAT_TYPE')}</Text>

                    <Text
                        className="ui5-text"
                        style={{
                            fontSize: ThemingParameters.sapFontSize,
                            color: ThemingParameters.sapContent_LabelColor,
                        }}
                    >
                        {t('TIME_FORMAT')}
                    </Text>
                    <TimeFormat />
                    <FlexBox
                        direction="Column"
                        className="footer"
                        style={{ gridColumn: 'span 2', marginTop: ThemingParameters.sapContent_Margin_Small }}
                    >
                        <hr
                            style={{
                                ...uiFullWidth,
                                borderTop: 'none',
                                borderColor: `${ThemingParameters.sapGroup_ContentBorderColor}`,
                                borderWidth: '2px',
                            }}
                        />
                        <Text
                            style={{
                                color: ThemingParameters.sapContent_LabelColor,
                                fontStyle: 'italic',
                                fontWeight: '400',
                                gridColumn: 'span 2',
                                fontSize: ThemingParameters.sapFontSmallSize,
                                marginTop: ThemingParameters.sapContent_Margin_Small,
                            }}
                        >
                            {t('SAVE_SETTING_MESSAGE')}
                        </Text>
                    </FlexBox>
                </ResponsiveGridLayout>
            </div>
        </div>
    );
};

export default LanguageRegion;
